<template>
  <div class="library-search-bar">
    <div class="search-box">
      <form ref="WorldCatSearch" role="form" id="search-form"
        name="search-form-world-cat" class="library-search-form world-cat"
        action="https://macalester.on.worldcat.org/search" method="get" data-stat-page-section="Header"
        data-stat-link-type="CUSTOM" data-stat-name="Search Button">
        <input placeholder="Search WorldCat for books, journals, videos and more..." id="WorldCatSearch"
          name="queryString" type="text" ref="searchQuery" autofocus="" class="the-header-search__input">
        <button class="the-header-search__input-button" type="submit" id="worldCatSubmit"
          @click="formSubmit('WorldCat')">
          <span data-v-7cd46e32="">Submit</span>
          <svg aria-hidden="true" viewbox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            class="base-symbol the-header-search__input-svg">
            <use xlink:href="/wp-content/themes/macalester-2020/dist/svgs/symbol-arrow.svg#icon"></use>
          </svg>
        </button>
      </form>
      <span class="advSearch"><a href="https://macalester.on.worldcat.org/advancedsearch?_gl=1*1kqyy4j*_ga*MzYwNjk3NDIyLjE2ODgwMTQwMjM.*_ga_TCD2B94FV6*MTY5MTYxMDk1NS42Ny4xLjE2OTE2MTE1ODMuNjAuMC4w" alt="World Cat Advanced Search" title="Advanced Search Link">Advanced Search</a></span>
    </div>
    <div class="hours-box">
      <span class="hours-title">library Hours</span>
      <span class="hours-range">{{ this.hours.open }} - {{ this.hours.closed }}</span>
      <span class="hours-title"><span :class="'orb ' + (this.parentData.isOpen ? 'open' : 'closed')"></span>{{this.parentData.isOpen ? "open" : "closed"}} {{this.parentData.isOpen ? "now" : "until " + this.hours.open}}</span>
      <a href="https://www.macalester.edu/calendar/building/?buildingId=8" title="Weekly Scheduled Hours" alt="Weekly Schedule link" class="base-cta dept-feature-url">Weekly Schedule</a>
    </div>
  </div>
</template>

<script>
import tag from '@/js/util/props/tag'
import { useAttrs } from 'vue';
import {checkTime, FormatTime} from '@/js/util/functions/helpers';


export default  {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: true,
      required: false
    },
    siteID:{
      type: Number,
      default: "{}",
    }
  },
 async created(){
    console.log('Received site ID:', this.$props.siteID);
    const data = await this.getData(this.$props.siteID)
    this.parentData = data;
    this.hours = {
      open: FormatTime(this.parentData.OpenDate),
      closed: FormatTime(this.parentData.CloseDate)
    }
  },
  methods: {
    selectSearchBar(option) {
      this.selectedBar = option;
    },
    getQueryParams() {
      var urlParams = {};
      var match;
      var pl = /\+/g; // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g;
      var decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      };
      var query = window.location.search.substring(1);
      while ((match = search.exec(query)))
        urlParams[decode(match[1])] = decode(match[2]);
      return urlParams;
    },
    formSubmit(bar) {
      event.preventDefault();
      this.$nextTick(() => {
        this.$refs.searchQuery.value = event.target.value;
      });
      this.$refs.WorldCatSearch.submit();
    },
    async getData(site_ID){
      try{
        const res = await fetch (`/wp-json/custom/v1/office-hours/?site_id${site_ID}`, {
          headers: {'X-API-KEY': 'f69c48a2-1f97-44d2-a5bc-70c2ead68449'}
        });

        
      const finalResponse = await res.json();
 
      const ParentHours = finalResponse[site_ID].active_time;
      const isOpen = await checkTime(ParentHours.opening_hours);
      const OpenDate = new Date;
      const CloseDate = new Date;
      OpenDate.setHours(ParentHours.opening_hours.start_time.split(":")[0]);
      OpenDate.setMinutes(ParentHours.opening_hours.start_time.split(":")[1]);
      CloseDate.setHours(ParentHours.opening_hours.end_time.split(":")[0]);
      CloseDate.setMinutes(ParentHours.opening_hours.end_time.split(":")[1]);
  
      return {...ParentHours, ...isOpen, OpenDate, CloseDate}
      }catch (error){
        console.log(error);
        //error with time feed using default time
        const OpenDate = new Date;
      const CloseDate = new Date;
      OpenDate.setHours(10);
      OpenDate.setMinutes(0);
      CloseDate.setHours(23);
      CloseDate.setMinutes(0);
      const isOpen = await checkTime({
        start_time: "10:00",
        end_time: "11:00"
      })

      return{ isOpen, OpenDate,CloseDate}
      }
 
  
    }
  },
  data() {
    return {
      selectedBar: "",
      parentData:{},
      hours: "",
    };
  },
  mounted() {
    var queryTerm = null;
    var qParams = this.getQueryParams();
    if (qParams.q && qParams.q.length && this.isSearch) {
      queryTerm = qParams.q;
      document.getElementById("LibrarySearchBar").value = queryTerm;
      this.selectedBar = "LibSearch";
    } else {
      this.selectedBar = "WorldCat";
    }


    
  }
};
</script>




// WEBPACK FOOTER //
// src/js/components/LibrarySearchBar.vue